export default __webpack_public_path__ + "static/media/icon-logs.ddeddf25.svg";